import { cn } from "@/lib/utils"

function Kbd({
  className,
  ...props
}) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "bg-muted text-slate-500 pointer-events-none inline-flex h-5 w-fit min-w-5 items-center justify-center gap-1 rounded-sm px-1 font-sans text-xs font-medium select-none",
        "[&_svg:not([class*='size-'])]:size-3",
        className
      )}
      {...props} />
  );
}

function KbdGroup({
  className,
  ...props
}) {
  return (
    <kbd
      data-slot="kbd-group"
      className={cn("inline-flex flex-wrap items-center gap-1", className)}
      {...props} />
  );
}

export { Kbd, KbdGroup }
